import { onDomReady } from "../../components/dynamic/observer";
import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';
import '../../../node_modules/swiper/swiper.scss';

function init() {

    const sliderElement = document.querySelector('[data-step-slider]');
    if (!sliderElement) return;

    const swiperContainer = sliderElement.querySelector('[data-step-slider-swiper]');
    const leftArrow = sliderElement.querySelector('[data-step-slider-left]');
    const rightArrow = sliderElement.querySelector('[data-step-slider-right]');
    const steps = sliderElement.querySelectorAll('[data-step-slider-step]');

    const setActiveStep = (index) => {

        steps.forEach(step => step.classList.remove('_active'));

        const active = sliderElement.querySelector(`[data-step-slider-step="${index}"]`);

        if (active) {
            active.classList.add('_active');
        }
    };

    const updateArrowsVisibility = (swiper) => {
        if (!leftArrow || !rightArrow) return;

        if (swiper.activeIndex === 0) {
            leftArrow.style.display = 'none';
        } else {
            leftArrow.style.display = '';
        }

        if (swiper.activeIndex === swiper.slides.length - 1) {
            rightArrow.style.display = 'none';
        } else {
            rightArrow.style.display = '';
        }
    };

    const slider = new Swiper(swiperContainer, {

        modules: [Navigation],

        slidesPerView: 1,
        autoHeight: true,
        speed: 600,

        navigation: {
            prevEl: leftArrow,
            nextEl: rightArrow,
        },

        on: {
            init(swiper) {
                setActiveStep(swiper.activeIndex);
                updateArrowsVisibility(swiper);
            },

            slideChange(swiper) {
                setActiveStep(swiper.activeIndex);
                updateArrowsVisibility(swiper);
            }
        }

    });

    steps.forEach(step => {

        step.addEventListener('click', () => {

            const index = Number(step.dataset.stepSliderStep);

            slider.slideTo(index);

        });

    });

}

onDomReady(init);